export default "__VITE_ASSET__Dsmz9vRL__"